import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import moment from 'moment-timezone';
import Button from '@spothero/ui/button';
import HorizontalRule from '@spothero/ui/horizontal-rule';
import Icon from 'common/icon/Icon';
import CardContentPanel from 'common/card/CardContentPanel';
import ParkingDateTimePanel from './purchase/ParkingDateTimePanel';
import ReviewPurchase from '../../checkout/summary/ReviewPurchase';

export default class AirportPurchaseInformationDetailsOnly extends Component {
    static propTypes = {
        facility: PropTypes.object,
        isFetchingRates: PropTypes.bool,
        spotId: PropTypes.number,
        starts: PropTypes.string,
        ends: PropTypes.string,
        availableTransientInventory: PropTypes.number,
        selectedRate: PropTypes.object,
        fetchRates: PropTypes.func.isRequired,
        isAirportRateUnavailable: PropTypes.bool,
        onCheckoutClick: PropTypes.func,
        pushTo: PropTypes.func,
        updateSelectedSpot: PropTypes.func
    };

    constructor(props) {
        super(props);

        const {
            isFetchingRates,
            starts,
            ends
        } = props;
        const startsMoment = (starts) ? moment(starts) : null;
        const endsMoment = (ends) ? moment(ends) : null;
        let isEditingDateTime = true;

        if (startsMoment && endsMoment && startsMoment.isBefore(endsMoment)) {
            isEditingDateTime = false;
        }

        this._DATE_TIME_FORMAT = 'MMM D [at] h:mma';

        this.state = {
            prevIsFetchingRates: isFetchingRates,
            isEditingDateTime
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const {
            isFetchingRates
        } = nextProps;

        if (prevState.prevIsFetchingRates && !isFetchingRates) {
            return {
                prevIsFetchingRates: isFetchingRates,
                isEditingDateTime: false
            };
        }

        return null;
    }

    _onDateTimeSearchClick = ({starts, ends}) => {
        const {
            spotId,
            fetchRates
        } = this.props;
        const fetchRatesParams = {
            spotId,
            starts,
            ends,
            airport: true,
        };

        fetchRates({
            ...fetchRatesParams,
            meta: {
                ...fetchRatesParams,
                monthly: false,
                dateTimeChanged: true
            }
        });
    }

    _onDateTimeEditClick = () => {
        this.setState({
            isEditingDateTime: true
        });
    }

    _onViewOtherOptionsClick = () => {
        const {
            facility: {
                airport: {
                    details: {
                        url
                    }
                }
            },
            starts,
            ends,
            pushTo,
            updateSelectedSpot
        } = this.props;
        let searchUrl = `/${url}`;

        if (starts && ends) {
            searchUrl += `?airport=true&starts=${starts}&ends=${ends}`;
        }

        updateSelectedSpot();
        pushTo(searchUrl);
    }

    _renderPanelPreview(section) {
        const {
            starts,
            ends
        } = this.props;
        const {
            isEditingDateTime
        } = this.state;

        switch (section) {
            case 'datetime':
                if (!isEditingDateTime) {
                    return (
                        <span className="CardContentPanel-preview-datetime">
                            {`${moment(starts).format(this._DATE_TIME_FORMAT)} - ${moment(ends).format(this._DATE_TIME_FORMAT)}`}
                        </span>
                    );
                } else {
                    return null;
                }
        }
    }

    _renderDateTimeEdit() {
        return (
            <Button
                className="CardContentPanel-title-actions"
                onClick={this._onDateTimeEditClick}
            >
                Edit
            </Button>
        );
    }

    render() {
        const {
            isFetchingRates,
            isAirportRateUnavailable,
            starts,
            ends,
            selectedRate,
            availableTransientInventory,
            onCheckoutClick,
        } = this.props;
        const {
            isEditingDateTime
        } = this.state;
        const datetimePreview = this._renderPanelPreview('datetime');
        const dateTimePanelClasses = classNames(
            'Panel-date-time',
            {'Panel-completed': !isEditingDateTime}
        );
        const availabilityMessage = (availableTransientInventory === 0)
            ? 'No spots left.'
            : `Only ${availableTransientInventory} spots left.`;

        return (
            <div className="AirportPurchaseInformation AirportPurchaseInformationDetailsOnly">
                {(availableTransientInventory <= 5) &&
                    <Fragment>
                        <div className="AirportPurchaseInformation-low-inventory">
                            <Icon name="clock" />
                            <span>{availabilityMessage}</span>
                        </div>
                        <HorizontalRule />
                    </Fragment>
                }
                <CardContentPanel
                    className={dateTimePanelClasses}
                    title="Parking Date/Time"
                    additionalTitleMarkup={(!isEditingDateTime)
                        ? this._renderDateTimeEdit()
                        : null}
                    preview={datetimePreview}
                    isOpen={isEditingDateTime}
                    showContentOnPrint={false}
                >
                    <ParkingDateTimePanel
                        isFetchingRates={isFetchingRates}
                        starts={starts}
                        ends={ends}
                        onSearchClick={this._onDateTimeSearchClick}
                    />
                </CardContentPanel>
                {selectedRate &&
                    <ReviewPurchase />
                }
                <Button
                    color="primary"
                    disabled={!selectedRate}
                    onClick={onCheckoutClick}
                    block
                >
                    Checkout
                </Button>
                {isAirportRateUnavailable &&
                    <div className="AirportPurchaseInformation-unavailable">
                        <Icon name="exclamation-circle" />
                        <p>We&apos;re sorry, this spot isn&apos;t available at the selected times.</p>
                        <Button
                            color="primary"
                            block
                            onClick={this._onViewOtherOptionsClick}
                        >
                            View Other Options
                        </Button>
                    </div>
                }
            </div>
        );
    }
}
